export default class SendNoteController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    SendNoteService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.SendNoteService = SendNoteService;

    this.note = {};
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  send(form) {
    if (form.$invalid) {
      return false;
    }

    this.SendNoteService.add({note: this.note})
      .then(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Wysłano sugestię')
            .position('bottom right')
            .hideDelay(3000)
        );
        this.$mdDialog.hide();
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}
